import React, { useState } from 'react';
import { Icon } from '@modulor/react';
import { Link } from 'react-router-dom';
import { NAMESPACES } from '../../../constants/namespaces';
import { getFavoritesRoute, getSearchRoute } from '../../../utils/routes';
import Local from '../../../components/Local/Local';
import ModalMenu from '../AppReviewModalMenu/AppReviewModalMenu';
import styles from './AppReviewHeader.module.css';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.header}>
      <div className={styles.title}>
        <Local>All Slots</Local>
      </div>

      <div className={styles.actions}>
        <Link to={getFavoritesRoute()} className={styles.btn}>
          <Icon size={20} name="star_filled" className={styles.icon} />
          <Local namespace={NAMESPACES.PAGES}>Favourites</Local>
        </Link>
        <Link to={getSearchRoute()} className={styles.btn}>
          <Icon size={20} name="search" className={styles.icon} />
          <Local namespace={NAMESPACES.PAGES}>Search</Local>
        </Link>

        <button className={styles.btn} onClick={() => setIsOpen(true)}>
          <Icon size={20} name="gear_outlined" className={styles.icon} />
          <Local>Menu</Local>
        </button>
      </div>

      <ModalMenu isOpen={isOpen} setIsOpen={setIsOpen} />
    </div>
  );
};

export default Header;
